import { render } from "./NotFoundData.vue?vue&type=template&id=51e73596&scoped=true"
import script from "./NotFoundData.vue?vue&type=script&lang=js"
export * from "./NotFoundData.vue?vue&type=script&lang=js"

import "./NotFoundData.vue?vue&type=style&index=0&id=51e73596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e73596"]])

export default __exports__